//
//
//
//
//
//
//
//
//
//
//
//
//
//

import breadCrumbs from '~/components/common/breadCrumbs.vue' // 面包屑
import navigationComp from '~/components/help/navigation.vue' // 左侧导航
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'navigation-comp': navigationComp
  },
  asyncData ({ route }) {
    const arr = [
      'lang-help-instructions-for-using-vps.html',
      'lang-help-vps-product-classification.html',
      'lang-help-buy-vps-server-process.html',
      'lang-help-helpWin.html',
      'lang-help-helpMac.html',
      'lang-help-mt4-account-binding-process.html',
      'lang-help-mt5-account-binding-process.html',
      'lang-help-ctrader-account-binding-process.html'
    ]
    const activeIndex = arr.findIndex(item => item == route.name)
    return {
      activeIndex
    }
  },
  data () {
    return {
      content: {
        'zh-cn': `
        <div class="title-box">VPS使用须知</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                            1.<strong>VPS用途</strong>：仅用于外汇交易，一般用于在MT4/MT5交易软件上使用EA进行程序化交易
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.<strong>使用期限</strong>：每次购买有效期为一个月，按月续费。续费费用依是否满足优惠续费条件为准（专属主机满足使用条件自动续费）。
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              3.<strong>普通版VPS</strong>首次购买，需在购买VPS后7个自然日内绑定交易账户。<span>若无绑定，则会在购买VPS后第二天开始，连续六个自然日收到警告短信和邮件提示，直至绑定成功。 否则VPS将在购买VPS后第八天自动回收</span>，同时用户将收到VPS回收短信提示。其他版本VPS无此限制。
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.若满足购买后7日内交易账户绑定成功，后续在VPS到期前5天会连续收到VPS即将到期短信提醒，直至到期回收。
                          </p>
                      </li>
                  </ul>
                  <p>
                      <strong>优惠续费条件：</strong>
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.需在到期前30日内续订（因此无法一次性续订多个月份）
                          </p>
                      </li>
                      <li>
                          <p>
                              2.用户在VPS上成功绑定实盘交易账户
                          </p>
                      </li>
                      <li>
                          <p>
                              3.用户绑定的交易账户每月至少有一笔实盘交易（至少有一笔平仓单）
                          </p>
                      </li>
                  </ul>
                  <p>
                      续费时候可看到以上规则，并可查看是否满足。若有异常可联系客服处理。
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            • 用户在开通VPS后，会收到VPS开通短信提醒。
                          </p>
                      </li>
                      <li>
                          <p>
                            • 用户删除VPS或VPS自动回收，也会收到VPS删除短信提醒。
                          </p>
                      </li>
                      <li>
                          <p>
                            • 用户在续费成功后，也会收到VPS续费成功短信提醒。
                          </p>
                      </li>
                      <li>
                          <p>
                            • 用户开通或续费VPS，若遇到支付后未成功开通或续费到期时间未改变，可及时联系客服处理。
                          </p>
                      </li>
                  </ul>
                  <p>
                      <strong>使用注意：</strong>
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.VPS原则上仅用于外汇交易。若用户在VPS上安装运行过多无关程序，则会影响系统稳定性，导致无法登录或程序运行卡顿等。
                          </p>
                      </li>
                      <li>
                          <p>
                              2.用户若在VPS上进行非法作业，如黑客攻击等行为，一旦被发现，VPS会随时被停止或回收。
                          </p>
                      </li>
                      <li>
                          <p>
                              3.用户在设置VPS密码时候，需尽量设置复杂度较高密码，否则易被入侵，造成损失。
                          </p>
                      </li>
                      <li>
                          <p>
                              4.目前VPS分普通和高配，普通版VPS可满足一般使用;若用户MT4/MT5软件中使用的EA占用较高资源（CPU或内存占用过高），可选择购买高配VPS。
                          </p>
                      </li>
                      <li>
                          <p>
                              5.一台VPS 最多可同时运行32个MT4/MT5。
                          </p>
                      </li>
                      <li>
                          <p>
                              6.VPS开通成功后，用户可在进入后台系统进行修改密码或重做系统等操作。
                          </p>
                      </li>
                      <li>
                          <p>
                              7.用户在使用VPS过程中遇到异常，可及时联系客服进行处理。
                          </p>
                      </li>
                  </ul>`,
        zh: `
        <div class="title-box">VPS使用須知</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.VPS用途：僅用於外匯交易，一般用於在MT4/MT5交易軟體上使用EA進行程式化交易
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.使用期限：每次購買有效期限為一個月，按月續費。續費費用依是否符合優惠續費條件為準（專屬主機滿足使用條件自動續費）。
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.普通版VPS首次購買，需在購買VPS後7個自然日內綁定交易帳戶。若無綁定，則會在購買VPS後第二天開始，連續六個自然日收到警告短信和郵件提示，直到綁定成功。 否則VPS將在購買VPS後第八天自動回收，同時用戶將收到VPS回收簡訊提示。其他版本VPS無此限制。
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.若滿足購買後7日內交易帳戶綁定成功，後續在VPS到期前5天會連續收到VPS即將到期簡訊提醒，直到到期回收。
                          </p>
                      </li>
                  </ul>
                  <p>
                      優惠續費條件：
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.需在到期前30日內續訂（因此無法一次續訂多個月份）
                          </p>
                      </li>
                      <li>
                          <p>
                              2.用戶在VPS上成功綁定實盤交易帳戶
                          </p>
                      </li>
                      <li>
                          <p>
                              3.用戶綁定的交易帳戶每月至少有一筆實盤交易（至少有一筆平倉單）
                          </p>
                      </li>
                  </ul>
                  <p>
                      續費時候可看到以上規則，並可查看是否滿足。 若有異常可聯絡客服處理。
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            • 用戶在開通VPS後，會收到VPS開通簡訊提醒。
                          </p>
                      </li>
                      <li>
                          <p>
                            • 用戶刪除VPS或VPS自動回收，也會收到VPS刪除簡訊提醒。
                          </p>
                      </li>
                      <li>
                          <p>
                            • 用戶在續費成功後，也會收到VPS續費成功簡訊提醒。
                          </p>
                      </li>
                      <li>
                          <p>
                            • 用戶開通或續費VPS，若遇到付款後未成功開通或續費到期時間未改變，可及時聯絡客服處理。
                          </p>
                      </li>
                  </ul>
                  <p>
                      使用注意：
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.VPS原則上僅用於外匯交易。 若使用者在VPS上安裝執行過多無關程序，則會影響系統穩定性，導致無法登入或程式執行卡頓等。
                          </p>
                      </li>
                      <li>
                          <p>
                              2.使用者若在VPS上進行非法作業，如駭客攻擊等行為，一旦被發現，VPS會隨時被停止或回收。
                          </p>
                      </li>
                      <li>
                          <p>
                              3.使用者設定VPS密碼時候，需盡量設定複雜度較高密碼，否則易被入侵，造成損失。
                          </p>
                      </li>
                      <li>
                          <p>
                              4.目前VPS分普通和高配，普通版VPS可滿足一般使用;若用戶MT4/MT5軟體中使用的EA佔用較高資源（CPU或內存佔用過高），可選擇購買高配VPS。
                          </p>
                      </li>
                      <li>
                          <p>
                              5.一台VPS 最多可同時運作32個MT4/MT5。
                          </p>
                      </li>
                      <li>
                          <p>
                              6.VPS開通成功後，使用者可在進入後台系統進行修改密碼或重做系統等操作。
                          </p>
                      </li>
                      <li>
                          <p>
                              7.使用者在使用VPS過程中遇到異常，可及時聯絡客服處理。
                          </p>
                      </li>
                  </ul>`,
        en: `
        <div class="title-box">Instructions for using VPS</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.VPS purpose: only used for foreign exchange transactions, generally used for programmatic trading using EA on MT4/MT5 trading software
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.Period of use: Each purchase is valid for one month and is renewed on a monthly basis. The renewal fee is subject to whether the preferential renewal conditions are met (the exclusive host will automatically renew if it meets the usage conditions).
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.For the first purchase of a regular VPS, you must bind your trading account within 7 natural days after purchasing the VPS. If you do not bind, you will receive warning SMS and email reminders for six consecutive natural days starting from the second day after purchasing the VPS until the binding is successful. Otherwise, the VPS will be automatically recycled on the eighth day after purchasing the VPS, and the user will receive a VPS recycling SMS reminder. There is no such restriction for other versions of VPS.
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.If the trading account is successfully bound within 7 days after purchase, you will receive text message reminders that the VPS is about to expire 5 days before the expiration of the VPS until it expires.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Discount renewal conditions:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.Subscription needs to be renewed within 30 days before expiration (so it cannot be renewed for multiple months at once)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.The user successfully binds a real trading account on the VPS
                          </p>
                      </li>
                      <li>
                          <p>
                              3.The trading account bound by the user must have at least one real transaction per month (with at least one closing order)
                          </p>
                      </li>
                  </ul>
                  <p>
                      You can see the above rules when renewing and check whether they are met. If there are any abnormalities, please contact customer service.
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            • After activating a VPS, the user will receive a VPS activation SMS reminder.
                          </p>
                      </li>
                      <li>
                          <p>
                            • If the user deletes the VPS or the VPS is automatically recycled, he will also receive a VPS deletion SMS reminder.
                          </p>
                      </li>
                      <li>
                          <p>
                            • After the user renews successfully, he will also receive a SMS reminder of successful VPS renewal.
                          </p>
                      </li>
                      <li>
                          <p>
                            • If a user activates or renews a VPS and fails to activate it successfully after payment or the renewal expiration date has not changed, he or she can contact customer service in time.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Notes on use:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.In principle, VPS is only used for foreign exchange transactions. If users install and run too many irrelevant programs on the VPS, it will affect system stability, resulting in the inability to log in or lags in program execution, etc.
                          </p>
                      </li>
                      <li>
                          <p>
                              2.If users conduct illegal operations on the VPS, such as hacker attacks, once discovered, the VPS will be stopped or recycled at any time.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.When setting the VPS password, users should try to set a password with higher complexity, otherwise it will be easily invaded and cause losses.
                          </p>
                      </li>
                      <li>
                          <p>
                              4.Currently, VPS is divided into normal and high configuration. The normal version of VPS can meet general use; if the EA used in the user&#39;s MT4/MT5 software takes up high resources (CPU or memory usage is too high), you can choose to purchase a high configuration VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                              5.A VPS can run up to 32 MT4/MT5 at the same time.
                          </p>
                      </li>
                      <li>
                          <p>
                              6.After the VPS is successfully opened, the user can enter the backend system to change the password or redo the system.
                          </p>
                      </li>
                      <li>
                          <p>
                              7.If users encounter abnormalities while using VPS, they can contact customer service in time for processing.
                          </p>
                      </li>
                  </ul>`,
        ru: `
        <div class="title-box">Инструкция по использованию VPS</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.Назначение VPS: используется только для валютных операций, обычно используется для программной торговли с использованием советника в торговом программном обеспечении MT4/MT5.
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.Срок использования: каждая покупка действительна в течение одного месяца и продлевается ежемесячно. Плата за продление зависит от того, соблюдены ли условия льготного продления (эксклюзивный хост будет автоматически продлеваться, если он соответствует условиям использования).
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.Если вы покупаете обычный VPS впервые, вы должны привязать свой торговый счет в течение 7 дней после покупки VPS. Если привязки нет, вы будете получать предупреждающие текстовые сообщения и напоминания по электронной почте в течение шести последовательных календарных дней, начиная со второго дня после покупки VPS, и до момента успешной привязки. В противном случае VPS будет автоматически переработан на восьмой день после покупки VPS, и пользователь получит SMS-напоминание об утилизации VPS. Другие версии VPS не имеют этого ограничения.
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.Если торговый счет успешно привязан в течение 7 дней после покупки, вы получите текстовое сообщение с напоминанием о том, что срок действия VPS истекает за 5 дней до истечения срока действия VPS, пока не истечет срок его действия.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Условия продления скидки:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.Подписку необходимо продлить в течение 30 дней до истечения срока действия (поэтому ее нельзя продлить на несколько месяцев одновременно).
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Пользователь успешно привязывает реальный торговый счет к VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.На торговом счете, привязанном пользователем, должна быть хотя бы одна реальная транзакция в месяц (с хотя бы одним ордером на закрытие)
                          </p>
                      </li>
                  </ul>
                  <p>
                      Вы можете увидеть вышеуказанные правила при продлении и проверить, соблюдаются ли они. Если есть какие-либо отклонения, пожалуйста, свяжитесь со службой поддержки клиентов.
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •После активации VPS пользователь получит SMS-напоминание об активации VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Если пользователь удаляет VPS или VPS автоматически перерабатывается, он также получит SMS-напоминание об удалении VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •После успешного продления пользователь также получит SMS-напоминание об успешном продлении VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Если пользователь активирует или продлевает VPS и не может успешно активировать его после оплаты или дата истечения срока продления не изменилась, он или она может вовремя обратиться в службу поддержки клиентов.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Примечания по использованию:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.В принципе, VPS используется только для валютных операций. Если пользователи установят и запустят на VPS слишком много ненужных программ, это повлияет на стабильность системы, что приведет к невозможности входа в систему или задержке выполнения программ и т. д.
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Если пользователи проводят незаконные операции на VPS, например хакерские атаки, после их обнаружения VPS будет остановлен или перезапущен в любое время.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.При установке пароля VPS пользователи должны стараться установить пароль более высокой сложности, в противном случае он будет легко взломан и приведет к потерям.
                          </p>
                      </li>
                      <li>
                          <p>
                              4.В настоящее время VPS подразделяется на обычную и высокую конфигурацию. Обычная версия VPS может использоваться для общего использования, если советник, используемый в программном обеспечении пользователя MT4/MT5, требует больших ресурсов (слишком высокое использование процессора или памяти); решите приобрести VPS высокой конфигурации.
                          </p>
                      </li>
                      <li>
                          <p>
                              5.На VPS может одновременно работать до 32 MT4/MT5.
                          </p>
                      </li>
                      <li>
                          <p>
                              6.После успешного открытия VPS пользователь может войти во внутреннюю систему, чтобы изменить пароль или переделать систему.
                          </p>
                      </li>
                      <li>
                          <p>
                              7.Если пользователи сталкиваются с аномалиями при использовании VPS, они могут вовремя обратиться в службу поддержки клиентов для обработки.
                          </p>
                      </li>
                  </ul>`,
        ja: `
        <div class="title-box">VPSの使用手順</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.VPS の目的: 外国為替取引のみに使用され、通常は MT4/MT5 取引ソフトウェア上の EA を使用したプログラム取引に使用されます。
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.利用期間：各購入は1ヶ月有効で、更新料は優先更新条件を満たしているかどうかに応じて適用されます（専用ホストは利用条件を満たしていれば自動更新されます）。
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.通常の VPS を初めて購入する場合は、VPS 購入後 7 自然日以内に取引アカウントをバインドする必要があります。バインドがない場合は、VPS 購入後の 2 日目からバインドが成功するまで、6 暦日連続で警告テキスト メッセージと電子メール リマインダーが届きます。 それ以外の場合、VPS は購入後 8 日目に自動的にリサイクルされ、ユーザーは VPS リサイクルの SMS リマインダーを受け取ります。他のバージョンの VPS にはこの制限はありません。
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.購入後 7 日以内に取引アカウントが正常にバインドされた場合は、VPS の有効期限が切れる 5 日前から有効期限が切れるまで、VPS の有効期限が近づいていることを通知するテキスト メッセージが届きます。
                          </p>
                      </li>
                  </ul>
                  <p>
                      割引の更新条件:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.サブスクリプションは有効期限の 30 日前までに更新する必要があります (そのため、一度に複数の月を更新することはできません)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.ユーザーは、VPS 上で実際の取引口座を正常にバインドします。
                          </p>
                      </li>
                      <li>
                          <p>
                              3.ユーザーがバインドする取引口座には、月に少なくとも 1 回の実際の取引が必要です (少なくとも 1 つの決済注文が含まれます)。
                          </p>
                      </li>
                  </ul>
                  <p>
                      更新時に上記のルールを確認し、満たしているかどうかを確認できます。 異常がある場合はカスタマーサービスまでご連絡ください。
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •VPS をアクティブ化すると、ユーザーは VPS アクティブ化の SMS リマインダーを受け取ります。
                          </p>
                      </li>
                      <li>
                          <p>
                            •ユーザーが VPS を削除するか、VPS が自動的にリサイクルされる場合、VPS 削除の SMS リマインダーも受信します。
                          </p>
                      </li>
                      <li>
                          <p>
                            •ユーザーが正常に更新すると、VPS 更新が成功したことを知らせる SMS リマインダーも受け取ります。
                          </p>
                      </li>
                      <li>
                          <p>
                            •ユーザーが VPS をアクティブ化または更新し、支払い後に正常にアクティブ化できなかった場合、または更新有効期限が変更されていない場合は、時間内にカスタマー サービスに問い合わせることができます。
                          </p>
                      </li>
                  </ul>
                  <p>
                      使用上の注意：
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.VPSは原則として外国為替取引のみに利用します。 ユーザーが VPS 上に無関係なプログラムをインストールして実行しすぎると、システムの安定性に影響が生じ、ログインできなくなったり、プログラムの実行に遅れが生じたりすることがあります。
                          </p>
                      </li>
                      <li>
                          <p>
                              2.ユーザーが VPS 上でハッカー攻撃などの違法な操作を行った場合、発見次第、いつでも VPS を停止またはリサイクルします。
                          </p>
                      </li>
                      <li>
                          <p>
                              3.VPS パスワードを設定するときは、より複雑なパスワードを設定するようにしてください。そうしないと、簡単に侵入され、損失が発生します。
                          </p>
                      </li>
                      <li>
                          <p>
                              4.現在、VPS は通常構成と高構成に分かれており、ユーザーの MT4/MT5 ソフトウェアで使用される EA が高いリソースを消費する場合 (CPU またはメモリ使用率が高すぎる場合)、通常バージョンの VPS は一般的な使用に対応できます。高構成の VPS を購入することを選択します。
                          </p>
                      </li>
                      <li>
                          <p>
                              5.VPS は同時に最大 32 の MT4/MT5 を実行できます。
                          </p>
                      </li>
                      <li>
                          <p>
                              6.VPS が正常に開かれた後、ユーザーはバックエンド システムに入り、パスワードを変更するか、システムをやり直すことができます。
                          </p>
                      </li>
                      <li>
                          <p>
                              7.ユーザーは、VPS の使用中に異常が発生した場合、処理に間に合うようにカスタマー サービスに連絡できます。
                          </p>
                      </li>
                  </ul>`,
        th: `
        <div class="title-box">คำแนะนำในการใช้ VPS</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.วัตถุประสงค์ของ VPS: ใช้สำหรับธุรกรรมแลกเปลี่ยนเงินตราต่างประเทศเท่านั้น โดยทั่วไปใช้สำหรับการซื้อขายแบบเป็นโปรแกรมโดยใช้ EA บนซอฟต์แวร์การซื้อขาย MT4/MT5
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.ระยะเวลาการใช้งาน: การซื้อแต่ละครั้งมีอายุหนึ่งเดือนและต่ออายุเป็นรายเดือน ค่าธรรมเนียมการต่ออายุขึ้นอยู่กับว่าเป็นไปตามเงื่อนไขการต่ออายุสิทธิพิเศษหรือไม่ (โฮสต์พิเศษจะต่ออายุโดยอัตโนมัติหากตรงตามเงื่อนไขการใช้งาน)
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.หากคุณซื้อ VPS ปกติเป็นครั้งแรก คุณจะต้องผูกบัญชีซื้อขายของคุณภายใน 7 วันธรรมดาหลังจากซื้อ VPS หากไม่มีข้อผูกมัด คุณจะได้รับข้อความเตือนและอีเมลแจ้งเตือนเป็นเวลาหกวันติดต่อกันตามปฏิทิน เริ่มตั้งแต่วันที่สองหลังจากซื้อ VPS จนกว่าการเชื่อมโยงจะสำเร็จ มิฉะนั้น VPS จะถูกรีไซเคิลโดยอัตโนมัติในวันที่แปดหลังจากซื้อ VPS และผู้ใช้จะได้รับ SMS เตือนการรีไซเคิล VPS VPS เวอร์ชันอื่นไม่มีข้อจำกัดนี้
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.หากผูกบัญชีซื้อขายสำเร็จภายใน 7 วันหลังจากการซื้อ คุณจะได้รับข้อความแจ้งเตือนว่า VPS กำลังจะหมดอายุ 5 วันก่อนหมดอายุของ VPS จนกว่าจะหมดอายุ
                          </p>
                      </li>
                  </ul>
                  <p>
                      เงื่อนไขการต่ออายุส่วนลด:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.การสมัครสมาชิกจะต้องต่ออายุภายใน 30 วันก่อนหมดอายุ (ดังนั้นจึงไม่สามารถต่ออายุได้หลายเดือนพร้อมกัน)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.ผู้ใช้ผูกบัญชีซื้อขายจริงบน VPS ได้สำเร็จ
                          </p>
                      </li>
                      <li>
                          <p>
                              3.บัญชีซื้อขายที่ผูกมัดโดยผู้ใช้จะต้องมีธุรกรรมจริงอย่างน้อยหนึ่งครั้งต่อเดือน (โดยมีคำสั่งปิดอย่างน้อยหนึ่งครั้ง)
                          </p>
                      </li>
                  </ul>
                  <p>
                      คุณสามารถดูกฎข้างต้นได้เมื่อต่ออายุและตรวจสอบว่าเป็นไปตามข้อกำหนดหรือไม่ หากมีความผิดปกติใดๆ โปรดติดต่อฝ่ายบริการลูกค้า
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •หลังจากเปิดใช้งาน VPS ผู้ใช้จะได้รับ SMS เตือนการเปิดใช้งาน VPS
                          </p>
                      </li>
                      <li>
                          <p>
                            •หากผู้ใช้ลบ VPS หรือ VPS ถูกรีไซเคิลโดยอัตโนมัติ เขาจะได้รับ SMS แจ้งเตือนการลบ VPS ด้วย
                          </p>
                      </li>
                      <li>
                          <p>
                            •หลังจากที่ผู้ใช้ต่ออายุสำเร็จแล้ว เขาจะได้รับ SMS แจ้งเตือนการต่ออายุ VPS ที่สำเร็จด้วย
                          </p>
                      </li>
                      <li>
                          <p>
                            •หากผู้ใช้เปิดใช้งานหรือต่ออายุ VPS และไม่สามารถเปิดใช้งานได้สำเร็จหลังจากการชำระเงินหรือวันหมดอายุการต่ออายุไม่มีการเปลี่ยนแปลง เขาหรือเธอสามารถติดต่อฝ่ายบริการลูกค้าได้ทันเวลา
                          </p>
                      </li>
                  </ul>
                  <p>
                      หมายเหตุเกี่ยวกับการใช้งาน:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.โดยหลักการแล้ว VPS ใช้สำหรับการทำธุรกรรมแลกเปลี่ยนเงินตราต่างประเทศเท่านั้น หากผู้ใช้ติดตั้งและรันโปรแกรมที่ไม่เกี่ยวข้องมากเกินไปบน VPS จะส่งผลต่อความเสถียรของระบบ ส่งผลให้ไม่สามารถเข้าสู่ระบบหรือล่าช้าในการทำงานของโปรแกรม เป็นต้น
                          </p>
                      </li>
                      <li>
                          <p>
                              2.หากผู้ใช้ดำเนินการที่ผิดกฎหมายบน VPS เช่น การโจมตีของแฮ็กเกอร์ เมื่อค้นพบแล้ว VPS จะถูกหยุดหรือรีไซเคิลได้ตลอดเวลา
                          </p>
                      </li>
                      <li>
                          <p>
                              3.เมื่อตั้งรหัสผ่าน VPS ผู้ใช้ควรพยายามตั้งรหัสผ่านที่มีความซับซ้อนสูงขึ้น มิฉะนั้นจะถูกบุกรุกได้ง่ายและทำให้เกิดการสูญเสีย
                          </p>
                      </li>
                      <li>
                          <p>
                              4.ปัจจุบัน VPS แบ่งออกเป็นการกำหนดค่าปกติและสูง VPS เวอร์ชันปกติสามารถตอบสนองการใช้งานทั่วไปได้ หาก EA ที่ใช้ในซอฟต์แวร์ MT4/MT5 ของผู้ใช้ใช้ทรัพยากรสูง (การใช้ CPU หรือหน่วยความจำสูงเกินไป) คุณสามารถทำได้ เลือกซื้อ VPS ที่มีการกำหนดค่าสูง
                          </p>
                      </li>
                      <li>
                          <p>
                              5.VPS สามารถทำงานได้สูงสุด 32 MT4/MT5 ในเวลาเดียวกัน
                          </p>
                      </li>
                      <li>
                          <p>
                              6.หลังจากเปิด VPS สำเร็จแล้ว ผู้ใช้สามารถเข้าสู่ระบบแบ็คเอนด์เพื่อเปลี่ยนรหัสผ่านหรือทำซ้ำระบบได้
                          </p>
                      </li>
                      <li>
                          <p>
                              7.หากผู้ใช้พบความผิดปกติขณะใช้งาน VPS พวกเขาสามารถติดต่อฝ่ายบริการลูกค้าได้ทันเวลาเพื่อดำเนินการ
                          </p>
                      </li>
                  </ul>`,
        vi: `
        <div class="title-box">Hướng dẫn sử dụng VPS</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.Mục đích của VPS: chỉ được sử dụng cho các giao dịch ngoại hối, thường được sử dụng cho giao dịch theo chương trình sử dụng EA trên phần mềm giao dịch MT4/MT5
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.Thời gian sử dụng: Mỗi lần mua có giá trị trong một tháng và được gia hạn hàng tháng tùy thuộc vào việc có đáp ứng các điều kiện gia hạn ưu đãi hay không (máy chủ độc quyền sẽ tự động gia hạn nếu đáp ứng các điều kiện sử dụng).
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.Nếu bạn mua VPS thông thường lần đầu tiên, bạn phải liên kết tài khoản giao dịch của mình trong vòng 7 ngày tự nhiên sau khi mua VPS. Nếu không có ràng buộc, bạn sẽ nhận được tin nhắn văn bản cảnh báo và lời nhắc qua email trong sáu ngày liên tục bắt đầu từ ngày thứ hai sau khi mua VPS cho đến khi ràng buộc thành công. Nếu không, VPS sẽ tự động được tái chế vào ngày thứ tám sau khi mua VPS và người dùng sẽ nhận được lời nhắc qua SMS về việc tái chế VPS. Các phiên bản VPS khác không có hạn chế này.
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.Nếu tài khoản giao dịch được liên kết thành công trong vòng 7 ngày sau khi mua, bạn sẽ nhận được tin nhắn nhắc nhở rằng VPS sắp hết hạn 5 ngày trước khi VPS hết hạn cho đến khi hết hạn.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Điều kiện gia hạn giảm giá:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.Đăng ký cần được gia hạn trong vòng 30 ngày trước khi hết hạn (vì vậy không thể gia hạn nhiều tháng cùng một lúc)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Người dùng liên kết thành công tài khoản giao dịch thực trên VPS
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Tài khoản giao dịch bị ràng buộc bởi người dùng phải có ít nhất một giao dịch thực mỗi tháng (có ít nhất một lệnh đóng)
                          </p>
                      </li>
                  </ul>
                  <p>
                      Bạn có thể xem các quy tắc trên khi gia hạn và kiểm tra xem chúng có được đáp ứng hay không. Nếu có bất kỳ sự bất thường nào, vui lòng liên hệ với bộ phận chăm sóc khách hàng.
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •Sau khi kích hoạt VPS, người dùng sẽ nhận được tin nhắn nhắc nhở kích hoạt VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Nếu người dùng xóa VPS hoặc VPS được tự động tái chế, anh ta cũng sẽ nhận được tin nhắn nhắc nhở xóa VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Sau khi người dùng gia hạn thành công cũng sẽ nhận được tin nhắn SMS nhắc nhở gia hạn VPS thành công.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Nếu người dùng kích hoạt hoặc gia hạn VPS và không kích hoạt thành công sau khi thanh toán hoặc ngày hết hạn gia hạn không thay đổi, người dùng có thể liên hệ bộ phận chăm sóc khách hàng kịp thời.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Lưu ý khi sử dụng:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.Về nguyên tắc, VPS chỉ được sử dụng cho các giao dịch ngoại hối. Nếu người dùng cài đặt và chạy quá nhiều chương trình không liên quan trên VPS sẽ ảnh hưởng đến độ ổn định của hệ thống, dẫn đến không đăng nhập được hoặc thực thi chương trình bị chậm, v.v.
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Nếu người dùng thực hiện các hoạt động bất hợp pháp trên VPS, chẳng hạn như tấn công của hacker, một khi bị phát hiện, VPS sẽ bị dừng hoặc tái chế bất cứ lúc nào.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Khi đặt mật khẩu VPS, người dùng nên cố gắng đặt mật khẩu có độ phức tạp cao hơn, nếu không sẽ dễ bị xâm phạm và gây thất thoát.
                          </p>
                      </li>
                      <li>
                          <p>
                              4.Hiện tại, VPS được chia thành cấu hình bình thường và cấu hình cao. Phiên bản thông thường của VPS có thể đáp ứng nhu cầu sử dụng chung; nếu EA sử dụng trong phần mềm MT4/MT5 của người dùng chiếm nhiều tài nguyên (mức sử dụng CPU hoặc bộ nhớ quá cao), bạn có thể thực hiện. chọn mua VPS cấu hình cao.
                          </p>
                      </li>
                      <li>
                          <p>
                              5.Một VPS có thể chạy tới 32 MT4/MT5 cùng một lúc.
                          </p>
                      </li>
                      <li>
                          <p>
                              6.Sau khi mở VPS thành công, người dùng có thể vào hệ thống phụ trợ để đổi mật khẩu hoặc làm lại hệ thống.
                          </p>
                      </li>
                      <li>
                          <p>
                              7.Nếu người dùng gặp bất thường trong quá trình sử dụng VPS, người dùng có thể liên hệ bộ phận chăm sóc khách hàng để kịp thời xử lý.
                          </p>
                      </li>
                  </ul>`,
        id: `
        <div class="title-box">Petunjuk penggunaan VPS</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.Tujuan VPS: hanya digunakan untuk transaksi valuta asing, umumnya digunakan untuk perdagangan terprogram menggunakan EA pada perangkat lunak perdagangan MT4/MT5
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.Periode penggunaan: Setiap pembelian berlaku selama satu bulan dan diperpanjang setiap bulan. Biaya perpanjangan tergantung pada apakah ketentuan perpanjangan preferensi terpenuhi (host eksklusif akan secara otomatis memperbarui jika memenuhi ketentuan penggunaan).
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.Jika Anda membeli VPS reguler untuk pertama kalinya, Anda harus mengikat akun trading Anda dalam waktu 7 hari setelah membeli VPS. Jika tidak ada pengikatan, Anda akan menerima pesan teks peringatan dan email pengingat selama enam hari kalender berturut-turut dimulai dari hari kedua setelah pembelian VPS hingga pengikatan berhasil. Jika tidak, VPS akan otomatis didaur ulang pada hari kedelapan setelah pembelian VPS, dan pengguna akan menerima SMS pengingat daur ulang VPS. VPS versi lain tidak memiliki batasan ini.
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.Jika akun trading berhasil diikat dalam waktu 7 hari setelah pembelian, Anda akan menerima pesan teks pengingat bahwa VPS akan segera kedaluwarsa 5 hari sebelum masa berlaku VPS hingga habis masa berlakunya.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Ketentuan perpanjangan diskon:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.Langganan perlu diperpanjang dalam waktu 30 hari sebelum habis masa berlakunya (jadi tidak dapat diperpanjang untuk beberapa bulan sekaligus)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Pengguna berhasil mengikat akun perdagangan nyata di VPS
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Akun perdagangan yang diikat oleh pengguna harus memiliki setidaknya satu transaksi nyata per bulan (dengan setidaknya satu pesanan penutupan)
                          </p>
                      </li>
                  </ul>
                  <p>
                      Anda dapat melihat aturan di atas saat memperbarui dan memeriksa apakah aturan tersebut terpenuhi. Jika ada kelainan, silakan hubungi layanan pelanggan.
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •Setelah mengaktifkan VPS, pengguna akan menerima SMS pengingat aktivasi VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Jika pengguna menghapus VPS atau VPS otomatis didaur ulang, ia juga akan menerima SMS pengingat penghapusan VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Setelah pengguna berhasil melakukan perpanjangan, ia juga akan menerima SMS pengingat perpanjangan VPS berhasil.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Jika pengguna mengaktifkan atau memperbarui VPS dan gagal mengaktifkannya setelah pembayaran atau tanggal kedaluwarsa perpanjangan tidak berubah, dia dapat menghubungi layanan pelanggan tepat waktu.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Catatan penggunaan:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.Pada prinsipnya VPS hanya digunakan untuk transaksi valuta asing. Jika pengguna menginstal dan menjalankan terlalu banyak program yang tidak relevan di VPS, hal ini akan mempengaruhi stabilitas sistem, mengakibatkan ketidakmampuan untuk login atau kelambatan dalam eksekusi program, dll.
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Jika pengguna melakukan operasi ilegal pada VPS, seperti serangan hacker, setelah ditemukan, VPS akan dihentikan atau didaur ulang kapan saja.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Saat mengatur kata sandi VPS, pengguna harus mencoba mengatur kata sandi dengan kompleksitas yang lebih tinggi, jika tidak maka akan mudah diserbu dan menyebabkan kerugian.
                          </p>
                      </li>
                      <li>
                          <p>
                              4.Saat ini, VPS dibagi menjadi konfigurasi normal dan tinggi. VPS versi normal dapat memenuhi penggunaan umum; jika EA yang digunakan pada perangkat lunak MT4/MT5 pengguna memakan sumber daya yang tinggi (penggunaan CPU atau memori terlalu tinggi), Anda dapat melakukannya. pilih untuk membeli VPS konfigurasi tinggi.
                          </p>
                      </li>
                      <li>
                          <p>
                              5.Sebuah VPS dapat menjalankan hingga 32 MT4/MT5 secara bersamaan.
                          </p>
                      </li>
                      <li>
                          <p>
                              6.Setelah VPS berhasil dibuka, pengguna dapat masuk ke sistem backend untuk mengubah password atau mengulang sistem.
                          </p>
                      </li>
                      <li>
                          <p>
                              7.Jika pengguna mengalami kelainan saat menggunakan VPS, mereka dapat menghubungi layanan pelanggan tepat waktu untuk diproses.
                          </p>
                      </li>
                  </ul>`,
        es: `
        <div class="title-box">Instrucciones para usar VPS</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.Propósito del VPS: solo se usa para transacciones de divisas, generalmente se usa para operaciones programáticas utilizando EA en el software de operaciones MT4/MT5.
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.Período de uso: Cada compra tiene una vigencia de un mes y se renueva mensualmente. La tarifa de renovación está sujeta a si se cumplen las condiciones de renovación preferencial (el host exclusivo renovará automáticamente si cumple con las condiciones de uso).
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.Si compra el VPS normal por primera vez, debe vincular su cuenta comercial dentro de los 7 días naturales posteriores a la compra del VPS. Si no hay vinculación, recibirá mensajes de texto de advertencia y recordatorios por correo electrónico durante seis días calendario consecutivos a partir del segundo día después de comprar el VPS hasta que la vinculación se realice correctamente. De lo contrario, el VPS se reciclará automáticamente al octavo día después de comprarlo y el usuario recibirá un SMS recordatorio de reciclaje del VPS. Otras versiones de VPS no tienen esta restricción.
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.Si la cuenta comercial se vincula exitosamente dentro de los 7 días posteriores a la compra, recibirá recordatorios por mensaje de texto de que el VPS está a punto de caducar 5 días antes del vencimiento del VPS hasta que caduque.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Condiciones de renovación del descuento:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.La suscripción debe renovarse dentro de los 30 días anteriores al vencimiento (por lo que no se puede renovar por varios meses a la vez)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.El usuario vincula con éxito una cuenta comercial real en el VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.La cuenta comercial vinculada por el usuario debe tener al menos una transacción real por mes (con al menos una orden de cierre)
                          </p>
                      </li>
                  </ul>
                  <p>
                      Puede ver las reglas anteriores al renovar y verificar si se cumplen. Si hay alguna anomalía, comuníquese con el servicio de atención al cliente.
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •Después de activar un VPS, el usuario recibirá un SMS de recordatorio de activación del VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Si el usuario elimina el VPS o el VPS se recicla automáticamente, también recibirá un SMS de recordatorio de eliminación del VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Después de que el usuario renueve exitosamente, también recibirá un recordatorio por SMS de la renovación exitosa del VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Si un usuario activa o renueva un VPS y no logra activarlo exitosamente después del pago o la fecha de vencimiento de la renovación no ha cambiado, puede comunicarse con el servicio de atención al cliente a tiempo.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Notas de uso:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.En principio, el VPS sólo se utiliza para transacciones de divisas. Si los usuarios instalan y ejecutan demasiados programas irrelevantes en el VPS, afectará la estabilidad del sistema, lo que resultará en la imposibilidad de iniciar sesión o retrasos en la ejecución del programa, etc.
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Si los usuarios realizan operaciones ilegales en el VPS, como ataques de piratas informáticos, una vez descubiertos, el VPS será detenido o reciclado en cualquier momento.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Al configurar la contraseña del VPS, los usuarios deben intentar establecer una contraseña con mayor complejidad; de lo contrario, será fácilmente invadida y provocará pérdidas.
                          </p>
                      </li>
                      <li>
                          <p>
                              4.Actualmente, VPS se divide en configuración normal y alta. La versión normal de VPS puede satisfacer el uso general. Si el EA utilizado en el software MT4/MT5 del usuario consume muchos recursos (el uso de CPU o memoria es demasiado alto), puede hacerlo. Elija comprar un VPS de alta configuración.
                          </p>
                      </li>
                      <li>
                          <p>
                              5.Un VPS puede ejecutar hasta 32 MT4/MT5 al mismo tiempo.
                          </p>
                      </li>
                      <li>
                          <p>
                              6.Después de abrir exitosamente el VPS, el usuario puede ingresar al sistema backend para cambiar la contraseña o rehacer el sistema.
                          </p>
                      </li>
                      <li>
                          <p>
                              7.Si los usuarios encuentran anomalías mientras usan VPS, pueden comunicarse con el servicio de atención al cliente a tiempo para su procesamiento.
                          </p>
                      </li>
                  </ul>`,
        hi: `
        <div class="title-box">वीपीएस का उपयोग करने के निर्देश</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.वीपीएस उद्देश्य: केवल विदेशी मुद्रा लेनदेन के लिए उपयोग किया जाता है, आमतौर पर एमटी4/एमटी5 ट्रेडिंग सॉफ्टवेयर पर ईए का उपयोग करके प्रोग्रामेटिक ट्रेडिंग के लिए उपयोग किया जाता है।
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.उपयोग की अवधि: प्रत्येक खरीदारी एक महीने के लिए वैध है और मासिक आधार पर नवीनीकृत की जाती है। नवीनीकरण शुल्क इस बात पर निर्भर करता है कि क्या अधिमानी नवीनीकरण शर्तें पूरी की जाती हैं (यदि विशेष होस्ट उपयोग की शर्तों को पूरा करता है तो स्वचालित रूप से नवीनीकृत हो जाएगा)।
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.यदि आप पहली बार नियमित वीपीएस खरीदते हैं, तो आपको वीपीएस खरीदने के बाद 7 दिनों के भीतर अपना ट्रेडिंग खाता लिंक करना होगा। यदि कोई बाइंडिंग नहीं है, तो आपको वीपीएस खरीदने के दूसरे दिन से लेकर बाइंडिंग सफल होने तक लगातार छह कैलेंडर दिनों तक चेतावनी पाठ संदेश और ईमेल अनुस्मारक प्राप्त होंगे। अन्यथा, वीपीएस खरीदने के आठवें दिन वीपीएस स्वचालित रूप से पुनर्चक्रित हो जाएगा, और उपयोगकर्ता को वीपीएस पुनर्चक्रण एसएमएस अनुस्मारक प्राप्त होगा। वीपीएस के अन्य संस्करणों में यह प्रतिबंध नहीं है।
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.यदि ट्रेडिंग खाता खरीद के बाद 7 दिनों के भीतर सफलतापूर्वक बंध जाता है, तो आपको टेक्स्ट संदेश अनुस्मारक प्राप्त होगा कि वीपीएस की समाप्ति से 5 दिन पहले वीपीएस समाप्त होने वाला है जब तक कि यह समाप्त न हो जाए।
                          </p>
                      </li>
                  </ul>
                  <p>
                      छूट नवीनीकरण की शर्तें:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.सदस्यता समाप्ति से 30 दिनों के भीतर नवीनीकृत की जानी चाहिए (इसलिए इसे एक साथ कई महीनों तक नवीनीकृत नहीं किया जा सकता है)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.उपयोगकर्ता सफलतापूर्वक वीपीएस पर एक वास्तविक ट्रेडिंग खाता बांधता है
                          </p>
                      </li>
                      <li>
                          <p>
                              3.उपयोगकर्ता द्वारा बाध्य ट्रेडिंग खाते में प्रति माह कम से कम एक वास्तविक लेनदेन होना चाहिए (कम से कम एक समापन आदेश के साथ)
                          </p>
                      </li>
                  </ul>
                  <p>
                      नवीनीकरण करते समय आप उपरोक्त नियमों को देख सकते हैं और जांच सकते हैं कि वे पूरे हुए हैं या नहीं। यदि कोई असामान्यताएं हैं, तो कृपया ग्राहक सेवा से संपर्क करें।
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •वीपीएस सक्रिय करने के बाद, उपयोगकर्ता को एक वीपीएस सक्रियण एसएमएस अनुस्मारक प्राप्त होगा।
                          </p>
                      </li>
                      <li>
                          <p>
                            •यदि उपयोगकर्ता वीपीएस हटा देता है या वीपीएस स्वचालित रूप से पुनर्चक्रित हो जाता है, तो उसे वीपीएस हटाने का एसएमएस अनुस्मारक भी प्राप्त होगा।
                          </p>
                      </li>
                      <li>
                          <p>
                            •उपयोगकर्ता के सफलतापूर्वक नवीनीकरण के बाद, उसे सफल वीपीएस नवीनीकरण का एक एसएमएस अनुस्मारक भी प्राप्त होगा।
                          </p>
                      </li>
                      <li>
                          <p>
                            •यदि कोई उपयोगकर्ता वीपीएस को सक्रिय या नवीनीकृत करता है और भुगतान के बाद इसे सफलतापूर्वक सक्रिय करने में विफल रहता है या नवीनीकरण की समाप्ति तिथि नहीं बदली है, तो वह समय पर ग्राहक सेवा से संपर्क कर सकता है।
                          </p>
                      </li>
                  </ul>
                  <p>
                      उपयोग पर नोट्स:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.सिद्धांत रूप में, वीपीएस का उपयोग केवल विदेशी मुद्रा लेनदेन के लिए किया जाता है। यदि उपयोगकर्ता वीपीएस पर बहुत सारे अप्रासंगिक प्रोग्राम इंस्टॉल और चलाते हैं, तो यह सिस्टम स्थिरता को प्रभावित करेगा, जिसके परिणामस्वरूप लॉग इन करने में असमर्थता होगी या प्रोग्राम निष्पादन में देरी होगी, आदि।
                          </p>
                      </li>
                      <li>
                          <p>
                              2.यदि उपयोगकर्ता वीपीएस पर अवैध संचालन करते हैं, जैसे कि हैकर के हमले, एक बार पता चलने पर, वीपीएस को किसी भी समय बंद कर दिया जाएगा या पुनर्चक्रित किया जाएगा।
                          </p>
                      </li>
                      <li>
                          <p>
                              3.वीपीएस पासवर्ड सेट करते समय, उपयोगकर्ताओं को अधिक जटिलता वाला पासवर्ड सेट करने का प्रयास करना चाहिए, अन्यथा इस पर आसानी से आक्रमण किया जाएगा और नुकसान होगा।
                          </p>
                      </li>
                      <li>
                          <p>
                              4.वर्तमान में, VPS को सामान्य और उच्च कॉन्फ़िगरेशन में विभाजित किया गया है, यदि उपयोगकर्ता के MT4/MT5 सॉफ़्टवेयर में उपयोग किया जाने वाला EA उच्च संसाधन लेता है (CPU या मेमोरी उपयोग बहुत अधिक है), तो आप सामान्य उपयोग को पूरा कर सकते हैं; उच्च कॉन्फ़िगरेशन वाला VPS खरीदना चुनें।
                          </p>
                      </li>
                      <li>
                          <p>
                              5.एक VPS एक ही समय में 32 MT4/MT5 तक चल सकता है।
                          </p>
                      </li>
                      <li>
                          <p>
                              6.वीपीएस सफलतापूर्वक खुलने के बाद, उपयोगकर्ता पासवर्ड बदलने या सिस्टम को फिर से करने के लिए बैकएंड सिस्टम में प्रवेश कर सकता है।
                          </p>
                      </li>
                      <li>
                          <p>
                              7.यदि उपयोगकर्ताओं को वीपीएस का उपयोग करते समय असामान्यताओं का सामना करना पड़ता है, तो वे प्रसंस्करण के लिए समय पर ग्राहक सेवा से संपर्क कर सकते हैं।
                          </p>
                      </li>
                  </ul>`,
        fil: `
        <div class="title-box">Mga tagubilin para sa paggamit ng VPS</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.Layunin ng VPS: ginagamit lang para sa mga transaksyon sa foreign exchange, karaniwang ginagamit para sa programmatic trading gamit ang EA sa MT4/MT5 trading software
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.Panahon ng paggamit: Ang bawat pagbili ay may bisa sa loob ng isang buwan at nire-renew sa buwanang batayan Ang bayad sa pag-renew ay napapailalim sa kung natutugunan ang mga kundisyon sa pag-renew (awtomatikong magre-renew ang eksklusibong host kung natutugunan nito ang mga kundisyon sa paggamit).
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.Kung bumili ka ng regular na VPS sa unang pagkakataon, dapat mong isailalim ang iyong trading account sa loob ng 7 natural na araw pagkatapos bilhin ang VPS. Kung walang pagbubuklod, makakatanggap ka ng mga text message ng babala at mga paalala sa email sa loob ng anim na magkakasunod na araw ng kalendaryo simula sa ikalawang araw pagkatapos bilhin ang VPS hanggang sa matagumpay na pag-binding. Kung hindi, ang VPS ay awtomatikong ire-recycle sa ikawalong araw pagkatapos bilhin ang VPS, at ang user ay makakatanggap ng VPS recycling SMS na paalala. Ang ibang mga bersyon ng VPS ay walang ganitong paghihigpit.
                          </p class="m24">
                      </li>
                      <li>
                          <p class="m30">
                              4.Kung matagumpay na nakatali ang trading account sa loob ng 7 araw pagkatapos ng pagbili, makakatanggap ka ng mga paalala sa text message na malapit nang mag-expire ang VPS 5 araw bago ang expiration ng VPS hanggang sa ito ay mag-expire.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Mga kondisyon sa pag-renew ng diskwento:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.Kailangang i-renew ang subscription sa loob ng 30 araw bago mag-expire (kaya hindi ito ma-renew nang maraming buwan nang sabay-sabay)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Ang gumagamit ay matagumpay na nagbubuklod ng isang tunay na trading account sa VPS
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Ang trading account na nakatali ng user ay dapat mayroong kahit isang tunay na transaksyon bawat buwan (na may kahit isang closing order)
                          </p>
                      </li>
                  </ul>
                  <p>
                      Maaari mong makita ang mga panuntunan sa itaas kapag nagre-renew at tingnan kung natutugunan ang mga ito. Kung mayroong anumang mga abnormalidad, mangyaring makipag-ugnayan sa customer service.
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •Pagkatapos mag-activate ng VPS, makakatanggap ang user ng VPS activation SMS reminder.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Kung tatanggalin ng user ang VPS o awtomatikong na-recycle ang VPS, makakatanggap din siya ng paalala ng SMS sa pagtanggal ng VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Pagkatapos ng matagumpay na pag-renew ng user, makakatanggap din siya ng SMS na paalala ng matagumpay na pag-renew ng VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Kung ang isang gumagamit ay nag-activate o nag-renew ng isang VPS at nabigo itong matagumpay na i-activate pagkatapos ng pagbabayad o ang petsa ng pag-expire ng renewal ay hindi nagbago, maaari siyang makipag-ugnayan sa customer service sa tamang oras.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Mga tala sa paggamit:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.Sa prinsipyo, ang VPS ay ginagamit lamang para sa mga transaksyon sa foreign exchange. Kung ang mga user ay nag-install at nagpapatakbo ng napakaraming hindi nauugnay na mga programa sa VPS, makakaapekto ito sa katatagan ng system, na magreresulta sa kawalan ng kakayahang mag-log in o mahuli sa pagpapatupad ng programa, atbp.
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Kung ang mga gumagamit ay nagsasagawa ng mga ilegal na operasyon sa VPS, tulad ng mga pag-atake ng hacker, kapag natuklasan, ang VPS ay ititigil o ire-recycle anumang oras.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Kapag nagtatakda ng password ng VPS, dapat subukan ng mga user na magtakda ng password na may mas mataas na kumplikado, kung hindi, madali itong ma-invade at magdudulot ng mga pagkalugi.
                          </p>
                      </li>
                      <li>
                          <p>
                              4.Sa kasalukuyan, ang VPS ay nahahati sa normal at mataas na configuration Ang normal na bersyon ng VPS ay maaaring matugunan ang pangkalahatang paggamit kung ang EA na ginagamit sa MT4/MT5 software ng gumagamit ay tumatagal ng mataas na mapagkukunan (CPU o paggamit ng memorya ay masyadong mataas), maaari mong. piliin na bumili ng mataas na configuration VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                              5.Ang isang VPS ay maaaring tumakbo ng hanggang 32 MT4/MT5 sa parehong oras.
                          </p>
                      </li>
                      <li>
                          <p>
                              6.Matapos matagumpay na mabuksan ang VPS, maaaring pumasok ang user sa backend system upang baguhin ang password o gawing muli ang system.
                          </p>
                      </li>
                      <li>
                          <p>
                              7.Kung ang mga user ay nakatagpo ng mga abnormalidad habang gumagamit ng VPS, maaari silang makipag-ugnayan sa customer service sa oras para sa pagproseso.
                          </p>
                      </li>
                  </ul>`,
        fr: `
        <div class="title-box">Instructions pour l'utilisation du VPS</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.Objectif VPS&nbsp;: utilisé uniquement pour les transactions de change, généralement utilisé pour le trading programmatique à l&#39;aide d&#39;EA sur le logiciel de trading MT4/MT5
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.Durée d&#39;utilisation : Chaque achat est valable un mois et se renouvelle mensuellement. Les frais de renouvellement sont soumis au respect des conditions préférentielles de renouvellement (l&#39;hébergeur exclusif renouvellera automatiquement s&#39;il remplit les conditions d&#39;utilisation).
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.Si vous achetez le VPS standard pour la première fois, vous devez lier votre compte de trading dans les 7 jours naturels suivant l'achat du VPS. S'il n'y a pas de liaison, vous recevrez des messages texte d'avertissement et des rappels par e-mail pendant six jours calendaires consécutifs à partir du deuxième jour après l'achat du VPS jusqu'à ce que la liaison soit réussie. Dans le cas contraire, le VPS sera automatiquement recyclé le huitième jour après l'achat du VPS, et l'utilisateur recevra un SMS de rappel de recyclage du VPS. Les autres versions de VPS n'ont pas cette restriction.
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.Si le compte de trading est lié avec succès dans les 7 jours suivant l&#39;achat, vous recevrez des rappels par SMS indiquant que le VPS est sur le point d&#39;expirer 5 jours avant l&#39;expiration du VPS jusqu&#39;à son expiration.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Conditions de renouvellement de la remise :
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.L&#39;abonnement doit être renouvelé dans les 30 jours avant l&#39;expiration (il ne peut donc pas être renouvelé plusieurs mois à la fois)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.L&#39;utilisateur réussit à lier un compte de trading réel sur le VPS
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Le compte de trading lié par l&#39;utilisateur doit avoir au moins une transaction réelle par mois (avec au moins un ordre de clôture)
                          </p>
                      </li>
                  </ul>
                  <p>
                      Vous pouvez consulter les règles ci-dessus lors du renouvellement et vérifier si elles sont respectées. S&#39;il y a des anomalies, veuillez contacter le service client.
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •Après avoir activé un VPS, l&#39;utilisateur recevra un SMS de rappel d&#39;activation du VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Si l&#39;utilisateur supprime le VPS ou que le VPS est automatiquement recyclé, il recevra également un SMS de rappel de suppression du VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Une fois le renouvellement réussi, l&#39;utilisateur recevra également un SMS de rappel du renouvellement réussi du VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Si un utilisateur active ou renouvelle un VPS et ne parvient pas à l&#39;activer avec succès après le paiement ou si la date d&#39;expiration du renouvellement n&#39;a pas changé, il peut contacter le service client à temps.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Notes d&#39;utilisation :
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.En principe, le VPS n&#39;est utilisé que pour les opérations de change. Si les utilisateurs installent et exécutent trop de programmes non pertinents sur le VPS, cela affectera la stabilité du système, entraînant une incapacité à se connecter ou un retard dans l&#39;exécution du programme, etc.
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Si les utilisateurs effectuent des opérations illégales sur le VPS, telles que des attaques de pirates informatiques, une fois découverts, le VPS sera arrêté ou recyclé à tout moment.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Lors de la définition du mot de passe VPS, les utilisateurs doivent essayer de définir un mot de passe plus complexe, sinon il sera facilement envahi et entraînera des pertes.
                          </p>
                      </li>
                      <li>
                          <p>
                              4.Actuellement, VPS est divisé en configuration normale et haute. La version normale de VPS peut répondre à une utilisation générale si l&#39;EA utilisé dans le logiciel MT4/MT5 de l&#39;utilisateur consomme des ressources élevées (l&#39;utilisation du CPU ou de la mémoire est trop élevée) ; choisissez d’acheter un VPS haute configuration.
                          </p>
                      </li>
                      <li>
                          <p>
                              5.Un VPS peut exécuter jusqu&#39;à 32 MT4/MT5 en même temps.
                          </p>
                      </li>
                      <li>
                          <p>
                              6.Une fois le VPS ouvert avec succès, l&#39;utilisateur peut accéder au système backend pour modifier le mot de passe ou refaire le système.
                          </p>
                      </li>
                      <li>
                          <p>
                              7.Si les utilisateurs rencontrent des anomalies lors de l&#39;utilisation du VPS, ils peuvent contacter le service client à temps pour le traitement.
                          </p>
                      </li>
                  </ul>`,
        de: `
        <div class="title-box">Anweisungen zur Verwendung von VPS</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.VPS-Zweck: Wird nur für Devisentransaktionen verwendet, im Allgemeinen für den programmatischen Handel mit EA auf der MT4/MT5-Handelssoftware
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.Nutzungsdauer: Jeder Kauf ist einen Monat lang gültig und wird monatlich verlängert. Die Verlängerungsgebühr hängt davon ab, ob die bevorzugten Verlängerungsbedingungen erfüllt sind (der exklusive Host verlängert automatisch, wenn er die Nutzungsbedingungen erfüllt).
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.Wenn Sie den regulären VPS zum ersten Mal kaufen, müssen Sie Ihr Handelskonto innerhalb von 7 Tagen nach dem Kauf des VPS binden. Erfolgt keine Bindung, erhalten Sie ab dem zweiten Tag nach dem Kauf des VPS an sechs aufeinanderfolgenden Kalendertagen Warn-SMS und E-Mail-Erinnerungen, bis die Bindung erfolgreich ist. Andernfalls wird der VPS am achten Tag nach dem Kauf des VPS automatisch recycelt und der Benutzer erhält eine SMS-Erinnerung zum VPS-Recycling. Andere Versionen von VPS haben diese Einschränkung nicht.
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.Wenn das Handelskonto innerhalb von 7 Tagen nach dem Kauf erfolgreich gebunden ist, erhalten Sie 5 Tage vor Ablauf des VPS bis zum Ablauf eine SMS-Erinnerung darüber, dass der VPS bald abläuft.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Bedingungen für die Verlängerung des Rabatts:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.Das Abonnement muss innerhalb von 30 Tagen vor Ablauf erneuert werden (es kann also nicht um mehrere Monate gleichzeitig verlängert werden).
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Der Benutzer bindet erfolgreich ein echtes Handelskonto an den VPS
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Das vom Nutzer gebundene Handelskonto muss mindestens eine echte Transaktion pro Monat (mit mindestens einer Schließungsorder) aufweisen.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Bei der Verlängerung können Sie die oben genannten Regeln einsehen und prüfen, ob diese eingehalten werden. Bei Auffälligkeiten wenden Sie sich bitte an den Kundendienst.
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •Nach der Aktivierung eines VPS erhält der Benutzer eine SMS-Erinnerung zur VPS-Aktivierung.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Wenn der Benutzer den VPS löscht oder der VPS automatisch recycelt wird, erhält er außerdem eine SMS-Erinnerung zum Löschen des VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Nach erfolgreicher Verlängerung erhält der Benutzer außerdem eine SMS-Erinnerung über die erfolgreiche VPS-Erneuerung.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Wenn ein Benutzer einen VPS aktiviert oder verlängert und die Aktivierung nach der Zahlung fehlschlägt oder sich das Ablaufdatum der Verlängerung nicht geändert hat, kann er sich rechtzeitig an den Kundendienst wenden.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Hinweise zur Verwendung:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.VPS wird grundsätzlich nur für Devisentransaktionen eingesetzt. Wenn Benutzer zu viele irrelevante Programme auf dem VPS installieren und ausführen, beeinträchtigt dies die Systemstabilität, was dazu führt, dass die Anmeldung nicht möglich ist oder die Programmausführung verzögert wird usw.
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Wenn Benutzer illegale Vorgänge auf dem VPS durchführen, wie z. B. Hackerangriffe, wird der VPS nach Entdeckung jederzeit gestoppt oder recycelt.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Beim Festlegen des VPS-Passworts sollten Benutzer versuchen, ein Passwort mit höherer Komplexität festzulegen, da es sonst leicht gehackt werden kann und zu Verlusten führt.
                          </p>
                      </li>
                      <li>
                          <p>
                              4.Derzeit ist VPS in normale und hohe Konfiguration unterteilt. Die normale Version von VPS kann allgemein verwendet werden, wenn der in der MT4/MT5-Software des Benutzers verwendete EA hohe Ressourcen beansprucht Entscheiden Sie sich für den Kauf eines VPS mit hoher Konfiguration.
                          </p>
                      </li>
                      <li>
                          <p>
                              5.Ein VPS kann bis zu 32 MT4/MT5 gleichzeitig ausführen.
                          </p>
                      </li>
                      <li>
                          <p>
                              6.Nachdem der VPS erfolgreich geöffnet wurde, kann der Benutzer das Backend-System betreten, um das Passwort zu ändern oder das System neu zu starten.
                          </p>
                      </li>
                      <li>
                          <p>
                              7.Sollten Benutzer bei der Nutzung von VPS auf Auffälligkeiten stoßen, können sie sich rechtzeitig zur Bearbeitung an den Kundendienst wenden.
                          </p>
                      </li>
                  </ul>`,
        pt: `
        <div class="title-box">Instruções para usar VPS</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.Finalidade do VPS: utilizado apenas para transacções cambiais, geralmente utilizado para negociação programática utilizando EA no software de negociação MT4/MT5
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.Período de utilização: Cada compra é válida por um mês e é renovada mensalmente. A taxa de renovação está sujeita ao cumprimento das condições preferenciais de renovação (o host exclusivo renovará automaticamente se cumprir as condições de utilização).
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.Se você comprar o VPS normal pela primeira vez, deverá vincular sua conta de negociação dentro de 7 dias naturais após a compra do VPS. Se não houver vinculação, você receberá mensagens de texto de aviso e lembretes por e-mail por seis dias consecutivos a partir do segundo dia após a compra do VPS até que a vinculação seja bem-sucedida. Caso contrário, o VPS será reciclado automaticamente no oitavo dia após a compra do VPS, e o usuário receberá um lembrete por SMS de reciclagem do VPS. Outras versões do VPS não possuem esta restrição.
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.Se a conta de negociação for vinculada com sucesso dentro de 7 dias após a compra, você receberá lembretes por mensagem de texto de que o VPS está prestes a expirar 5 dias antes da expiração do VPS, até que ele expire.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Condições de renovação do desconto:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.A assinatura precisa ser renovada 30 dias antes do vencimento (portanto, não pode ser renovada por vários meses de uma vez)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.O usuário vincula com sucesso uma conta de negociação real no VPS
                          </p>
                      </li>
                      <li>
                          <p>
                              3.A conta de negociação vinculada pelo usuário deve ter pelo menos uma transação real por mês (com pelo menos uma ordem de fechamento)
                          </p>
                      </li>
                  </ul>
                  <p>
                      Você pode ver as regras acima ao renovar e verificar se elas são cumpridas. Se houver alguma anormalidade, entre em contato com o atendimento ao cliente.
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •Após ativar um VPS, o usuário receberá um lembrete por SMS de ativação do VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Se o usuário excluir o VPS ou o VPS for reciclado automaticamente, ele também receberá um lembrete por SMS de exclusão do VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Após o usuário renovar com sucesso, ele também receberá um lembrete por SMS de renovação bem-sucedida do VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Se um usuário ativar ou renovar um VPS e não conseguir ativá-lo com sucesso após o pagamento ou a data de expiração da renovação não tiver mudado, ele poderá entrar em contato com o atendimento ao cliente a tempo.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Notas sobre uso:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.Em princípio, o VPS só é utilizado para transacções cambiais. Se os usuários instalarem e executarem muitos programas irrelevantes no VPS, isso afetará a estabilidade do sistema, resultando na incapacidade de fazer login ou atrasos na execução do programa, etc.
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Se os usuários realizarem operações ilegais no VPS, como ataques de hackers, uma vez descobertos, o VPS será interrompido ou reciclado a qualquer momento.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Ao definir a senha do VPS, o usuário deve tentar definir uma senha com maior complexidade, caso contrário ela será facilmente invadida e causará prejuízos.
                          </p>
                      </li>
                      <li>
                          <p>
                              4.Atualmente, o VPS é dividido em configuração normal e alta. A versão normal do VPS pode atender ao uso geral se o EA usado no software MT4/MT5 do usuário consumir muitos recursos (uso de CPU ou memória for muito alto); opte por adquirir um VPS de alta configuração.
                          </p>
                      </li>
                      <li>
                          <p>
                              5.Um VPS pode executar até 32 MT4/MT5 ao mesmo tempo.
                          </p>
                      </li>
                      <li>
                          <p>
                              6.Após a abertura bem-sucedida do VPS, o usuário pode entrar no sistema backend para alterar a senha ou refazer o sistema.
                          </p>
                      </li>
                      <li>
                          <p>
                              7.Se os usuários encontrarem anormalidades ao usar o VPS, eles poderão entrar em contato com o atendimento ao cliente a tempo de processar.
                          </p>
                      </li>
                  </ul>`,
        tr: `
        <div class="title-box">VPS'yi kullanma talimatları</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.VPS amacı: yalnızca döviz işlemleri için kullanılır, genellikle MT4/MT5 ticaret yazılımında EA kullanılarak programlı ticaret için kullanılır
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.Kullanım süresi: Her satın alma bir ay süreyle geçerlidir ve aylık olarak yenilenir. Yenileme ücreti, tercihli yenileme koşullarının karşılanıp karşılanmadığına bağlıdır (münhasır ev sahibi, kullanım koşullarını karşılaması durumunda otomatik olarak yenilenecektir).
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.Normal VPS'yi ilk kez satın alıyorsanız, alım satım hesabınızı VPS'yi satın aldıktan sonraki 7 doğal gün içinde bağlamanız gerekir. Bağlama yoksa, VPS'yi satın aldıktan sonraki ikinci günden başlayarak bağlama başarılı olana kadar art arda altı takvim günü boyunca uyarı metin mesajları ve e-posta hatırlatıcıları alacaksınız. Aksi takdirde VPS, VPS'yi satın aldıktan sonraki sekizinci günde otomatik olarak geri dönüştürülecek ve kullanıcıya bir VPS geri dönüşüm SMS hatırlatıcısı gönderilecektir. VPS'nin diğer sürümlerinde bu kısıtlama yoktur.
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.Yatırım hesabı, satın alma işleminden sonraki 7 gün içinde başarılı bir şekilde bağlanırsa, VPS&#39;nin sona ermesinden 5 gün önce, süresi dolana kadar VPS&#39;nin süresinin dolmak üzere olduğunu hatırlatan kısa mesaj alacaksınız.
                          </p>
                      </li>
                  </ul>
                  <p>
                      İndirim yenileme koşulları:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.Aboneliğin sona ermeden önceki 30 gün içinde yenilenmesi gerekir (bu nedenle aynı anda birden fazla ay boyunca yenilenemez)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Kullanıcı, VPS&#39;de gerçek bir ticaret hesabını başarıyla bağlar
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Kullanıcının bağlı olduğu işlem hesabında ayda en az bir gerçek işlem (en az bir kapatma emri ile) bulunmalıdır.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Yenileme yaparken yukarıdaki kuralları görebilir ve karşılanıp karşılanmadığını kontrol edebilirsiniz. Herhangi bir anormallik varsa lütfen müşteri hizmetlerine başvurun.
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •Bir VPS&#39;yi etkinleştirdikten sonra kullanıcı bir VPS etkinleştirme SMS hatırlatıcısı alacaktır.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Kullanıcı VPS&#39;yi silerse veya VPS otomatik olarak geri dönüştürülürse, ayrıca bir VPS silme SMS hatırlatıcısı da alacaktır.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Kullanıcı başarıyla yenilendikten sonra, başarılı VPS yenilemesine ilişkin bir SMS hatırlatıcısı da alacaktır.
                          </p>
                      </li>
                      <li>
                          <p>
                            •Bir kullanıcı bir VPS&#39;yi etkinleştirir veya yenilerse ve ödeme yapıldıktan sonra başarılı bir şekilde etkinleştiremezse veya yenilemenin son tarihi değişmediyse, müşteri hizmetleriyle zamanında iletişime geçebilir.
                          </p>
                      </li>
                  </ul>
                  <p>
                      Kullanımla ilgili notlar:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.Prensip olarak VPS yalnızca döviz işlemleri için kullanılır. Kullanıcılar VPS&#39;ye çok sayıda alakasız program yükler ve çalıştırırsa, bu durum sistem kararlılığını etkileyerek oturum açamamaya veya program yürütmede gecikmelere vb. neden olur.
                          </p>
                      </li>
                      <li>
                          <p>
                              2.Kullanıcıların VPS üzerinde hacker saldırıları gibi yasa dışı işlemler gerçekleştirmesi halinde, tespit edildikten sonra VPS herhangi bir zamanda durdurulacak veya geri dönüştürülecektir.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.Kullanıcılar VPS şifresini ayarlarken daha karmaşık bir şifre belirlemeye çalışmalıdır, aksi takdirde şifre kolayca ele geçirilebilir ve kayıplara neden olabilir.
                          </p>
                      </li>
                      <li>
                          <p>
                              4.Şu anda VPS normal ve yüksek konfigürasyona ayrılmıştır. VPS&#39;nin normal sürümü genel kullanımı karşılayabilir; eğer kullanıcının MT4/MT5 yazılımında kullanılan EA yüksek kaynakları kaplıyorsa (CPU veya bellek kullanımı çok yüksek), bunu yapabilirsiniz. yüksek konfigürasyonlu bir VPS satın almayı seçin.
                          </p>
                      </li>
                      <li>
                          <p>
                              5.Bir VPS aynı anda 32 adete kadar MT4/MT5 çalıştırabilir.
                          </p>
                      </li>
                      <li>
                          <p>
                              6.VPS başarıyla açıldıktan sonra kullanıcı arka uç sisteme girerek şifreyi değiştirebilir veya sistemi yeniden yapabilir.
                          </p>
                      </li>
                      <li>
                          <p>
                              7.Kullanıcılar VPS&#39;yi kullanırken anormalliklerle karşılaşırsa, işlem için zamanında müşteri hizmetleriyle iletişime geçebilirler.
                          </p>
                      </li>
                  </ul>`,
        ko: `
        <div class="title-box">VPS 사용 지침</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.VPS 목적: 외환 거래에만 사용되며 일반적으로 MT4/MT5 거래 소프트웨어에서 EA를 사용하는 프로그래밍 방식 거래에 사용됩니다.
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.사용 기간: 각 구매는 1개월 동안 유효하며 매월 갱신됩니다. 갱신 수수료는 우선 갱신 조건 충족 여부에 따라 달라집니다. (전용 호스트는 사용 조건을 충족할 경우 자동으로 갱신됩니다.)
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.VPS 정식 버전을 처음 구매하는 경우, VPS 구매 후 7일 이내에 거래 계좌를 연결해야 합니다. 바인딩이 없는 경우 VPS 구매 후 둘째 날부터 바인딩이 성공할 때까지 연속 6일 동안 경고 문자 메시지와 이메일 알림을 받게 됩니다. 그렇지 않은 경우 VPS는 구매 후 8일째에 자동으로 재활용되며 사용자는 VPS 재활용 SMS 알림을 받게 됩니다. 다른 VPS 버전에는 이러한 제한이 없습니다.
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.구매 후 7일 이내에 거래 계좌 연결에 성공하면 VPS가 만료되기 5일 전부터 VPS가 만료될 때까지 VPS가 곧 만료된다는 알림 문자 메시지를 받게 됩니다.
                          </p>
                      </li>
                  </ul>
                  <p>
                      할인 갱신 조건:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.구독은 만료 전 30일 이내에 갱신되어야 합니다. (따라서 한 번에 여러 달 동안 갱신할 수 없습니다.)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.사용자가 VPS에서 실제 거래 계좌를 성공적으로 연결했습니다.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.사용자가 연결한 거래 계좌에는 매월 최소 1건의 실제 거래가 있어야 합니다(최소 1건의 마감 주문 포함).
                          </p>
                      </li>
                  </ul>
                  <p>
                      갱신 시 위의 규칙을 확인하고, 충족 여부를 확인할 수 있습니다. 이상이 있을 경우 고객센터로 연락주시기 바랍니다.
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •VPS를 활성화한 후 사용자는 VPS 활성화 SMS 알림을 받게 됩니다.
                          </p>
                      </li>
                      <li>
                          <p>
                            •사용자가 VPS를 삭제하거나 VPS가 자동으로 재활용되는 경우에도 VPS 삭제 알림을 받게 됩니다.
                          </p>
                      </li>
                      <li>
                          <p>
                            •사용자가 성공적으로 갱신한 후에는 VPS 갱신 성공을 알리는 SMS 알림도 받게 됩니다.
                          </p>
                      </li>
                      <li>
                          <p>
                            •사용자가 VPS를 활성화 또는 갱신하고 결제 후 성공적으로 활성화하지 못하거나 갱신 만료일이 변경되지 않은 경우 고객 서비스에 적시에 문의할 수 있습니다.
                          </p>
                      </li>
                  </ul>
                  <p>
                      사용 시 참고 사항:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.VPS는 원칙적으로 외환거래에만 사용됩니다. 사용자가 VPS에 관련없는 프로그램을 너무 많이 설치하여 실행하면 시스템 안정성에 영향을 미치고, 로그인이 불가능하거나 프로그램 실행이 지연되는 등의 문제가 발생합니다.
                          </p>
                      </li>
                      <li>
                          <p>
                              2.사용자가 VPS를 이용하여 해커 공격 등 불법적인 작업을 수행한 경우 적발되면 VPS는 언제든지 중지되거나 재활용됩니다.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.VPS 비밀번호를 설정할 때 사용자는 더 복잡한 비밀번호를 설정해야 합니다. 그렇지 않으면 쉽게 침입당하여 손실이 발생할 수 있습니다.
                          </p>
                      </li>
                      <li>
                          <p>
                              4.현재 VPS는 일반 버전과 고급 구성으로 구분됩니다. 사용자의 MT4/MT5 소프트웨어에서 사용되는 EA가 높은 리소스를 차지하는 경우(CPU 또는 메모리 사용량이 너무 높음) 일반 버전의 VPS가 일반 용도에 적합합니다. 높은 구성의 VPS를 구매하기로 선택하세요.
                          </p>
                      </li>
                      <li>
                          <p>
                              5.VPS는 동시에 최대 32개의 MT4/MT5를 실행할 수 있습니다.
                          </p>
                      </li>
                      <li>
                          <p>
                              6.VPS가 성공적으로 열린 후 사용자는 백엔드 시스템에 들어가 비밀번호를 변경하거나 시스템을 다시 실행할 수 있습니다.
                          </p>
                      </li>
                      <li>
                          <p>
                              7.VPS 이용 중 이상이 발생한 경우, 고객센터로 연락주시면 처리가 가능합니다.
                          </p>
                      </li>
                  </ul>`,
        ar: `
        <div class="title-box">تعليمات لاستخدام VPS</div>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p class="m24">
                              1.غرض VPS: يستخدم فقط لمعاملات الصرف الأجنبي، ويستخدم بشكل عام للتداول الآلي باستخدام EA على برنامج التداول MT4/MT5
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                              2.فترة الاستخدام: كل عملية شراء صالحة لمدة شهر واحد ويتم تجديدها على أساس شهري، وتخضع رسوم التجديد لمدى استيفاء شروط التجديد التفضيلية (سيتم تجديد المضيف الحصري تلقائيًا إذا استوفى شروط الاستخدام).
                          </p>
                      </li>
                      <li>
                          <p class="m24">
                            3.عند شراء الإصدار العادي من VPS لأول مرة، يجب أن يكون حساب التداول مقيدًا خلال 7 أيام طبيعية بعد شراء VPS. إذا لم يكن هناك ربط، فسوف تتلقى رسائل نصية تحذيرية وتذكيرات عبر البريد الإلكتروني لمدة ستة أيام تقويمية متتالية بدءًا من اليوم الثاني بعد شراء VPS حتى يتم الربط بنجاح. بخلاف ذلك، سيتم إعادة تدوير VPS تلقائيًا في اليوم الثامن بعد شراء VPS، وسيتلقى المستخدم رسالة تذكير عبر الرسائل القصيرة الخاصة بإعادة تدوير VPS. الإصدارات الأخرى من VPS لا تحتوي على هذا القيد..
                          </p>
                      </li>
                      <li>
                          <p class="m30">
                              4.إذا تم ربط حساب التداول بنجاح خلال 7 أيام بعد الشراء، فسوف تتلقى رسائل تذكير نصية بأن الخادم الافتراضي الخاص (VPS) على وشك الانتهاء قبل 5 أيام من انتهاء صلاحية الخادم الافتراضي الخاص (VPS) حتى تنتهي صلاحيته.
                          </p>
                      </li>
                  </ul>
                  <p>
                      شروط تجديد الخصم:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.يجب تجديد الاشتراك خلال 30 يومًا قبل انتهاء الصلاحية (لذلك لا يمكن تجديده لعدة أشهر مرة واحدة)
                          </p>
                      </li>
                      <li>
                          <p>
                              2.نجح المستخدم في ربط حساب تداول حقيقي على الخادم الافتراضي الخاص (VPS).
                          </p>
                      </li>
                      <li>
                          <p>
                              3.يجب أن يكون لدى حساب التداول المرتبط بالمستخدم معاملة حقيقية واحدة على الأقل شهريًا (مع أمر إغلاق واحد على الأقل)
                          </p>
                      </li>
                  </ul>
                  <p>
                      يمكنك الاطلاع على القواعد المذكورة أعلاه عند التجديد والتحقق من استيفاءها. إذا كان هناك أي خلل، يرجى الاتصال بخدمة العملاء.
                  </p>
                  <ul class="list-bullet1 list-paddingleft-2">
                      <li>
                          <p>
                            •بعد تفعيل VPS، سيتلقى المستخدم رسالة تذكير عبر الرسائل القصيرة لتفعيل VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •إذا قام المستخدم بحذف VPS أو تمت إعادة تدوير VPS تلقائيًا، فسيتلقى أيضًا تذكيرًا عبر الرسائل القصيرة بحذف VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •بعد أن يتم التجديد بنجاح، سيتلقى المستخدم أيضًا تذكيرًا عبر الرسائل القصيرة SMS بنجاح تجديد VPS.
                          </p>
                      </li>
                      <li>
                          <p>
                            •إذا قام المستخدم بتنشيط أو تجديد VPS وفشل في تنشيطه بنجاح بعد الدفع أو لم يتغير تاريخ انتهاء التجديد، فيمكنه الاتصال بخدمة العملاء في الوقت المناسب.
                          </p>
                      </li>
                  </ul>
                  <p>
                      ملاحظات حول الاستخدام:
                  </p>
                  <ul class="list-number1 list-paddingleft-2">
                      <li>
                          <p>
                              1.من حيث المبدأ، يتم استخدام VPS فقط لمعاملات الصرف الأجنبي. إذا قام المستخدمون بتثبيت وتشغيل عدد كبير جدًا من البرامج غير ذات الصلة على VPS، فسيؤثر ذلك على استقرار النظام، مما يؤدي إلى عدم القدرة على تسجيل الدخول أو التأخر في تنفيذ البرنامج، وما إلى ذلك.
                          </p>
                      </li>
                      <li>
                          <p>
                             2.إذا قام المستخدمون بإجراء عمليات غير قانونية على الخادم الافتراضي الخاص، مثل هجمات القراصنة، بمجرد اكتشافها، سيتم إيقاف الخادم الافتراضي الخاص أو إعادة استخدامه في أي وقت.
                          </p>
                      </li>
                      <li>
                          <p>
                              3.عند تعيين كلمة مرور VPS، يجب على المستخدمين محاولة تعيين كلمة مرور ذات تعقيد أعلى، وإلا سيتم اختراقها بسهولة والتسبب في خسائر.
                          </p>
                      </li>
                      <li>
                          <p>
                              4.حاليًا، ينقسم VPS إلى تكوين عادي وعالي، يمكن للإصدار العادي من VPS أن يلبي الاستخدام العام، إذا كان EA المستخدم في برنامج MT4/MT5 الخاص بالمستخدم يستهلك موارد عالية (استخدام وحدة المعالجة المركزية أو الذاكرة مرتفع جدًا)؛ اختر شراء VPS عالي التكوين.
                          </p>
                      </li>
                      <li>
                          <p>
                              5.يمكن لـ VPS تشغيل ما يصل إلى 32 MT4/MT5 في نفس الوقت.
                          </p>
                      </li>
                      <li>
                          <p>
                              6.بعد فتح VPS بنجاح، يمكن للمستخدم الدخول إلى نظام الواجهة الخلفية لتغيير كلمة المرور أو إعادة النظام.
                          </p>
                      </li>
                      <li>
                          <p>
                              7.إذا واجه المستخدمون خللًا أثناء استخدام VPS، فيمكنهم الاتصال بخدمة العملاء في الوقت المناسب للمعالجة.
                          </p>
                      </li>
                  </ul>`
      }
    }
  },
  head () {
    return {
      title: this.$t('40592'),
      meta: [
        { name: 'Description', content: this.$t('40593') }
      ]
    }
  }
}
